import { useTranslation } from "@i18n";
import type { ObjectIdString } from "@Helpers/schemas/common.schema";
import { useState, Suspense, lazy } from "react";
import { useSelector } from "react-redux";
import Forbidden from "../../../../pages/Error/Forbidden";
import { useParams } from "react-router-dom";
import _ from "lodash";
import Text from "@CubeComponents/html/Text/Text";
import { formCategories } from "@Helpers";
import Forms from "@Features/portal-settings/components/PortalSetings/Configuration/FormsAndFields/Forms";
import { formTemplateSource } from "@Features/portal-settings";
import { RootState } from "@Reducers/index";

const FormTemplate = lazy(() => import("@Features/projects/components/ProjectSetings/Configuration/FormTemplate"));

function AssetsSetting() {
  const { t } = useTranslation();
  const params = useParams();
  const getProjectSettingObject = useSelector((state: RootState) => state.getProjectSettingObject);
  const [activeTab, setActiveTab] = useState<"INSTANCE_TEMPLATE" | "PROJECT_LEVEL_TEMPLATE">("INSTANCE_TEMPLATE");

  const activeButton = "text-base text-[color:var(--primary-text)] font-semibold";
  const singleButtonStyle = "text-base text-[color:var(--primary-text)] cursor-pointer";

  const tabs = [
    { id: "INSTANCE_TEMPLATE" as const, label: t("Instance Template") },
    { id: "PROJECT_LEVEL_TEMPLATE" as const, label: t("Project Level Template") },
  ];

  return (
    <>
      {_.get(getProjectSettingObject, "formTemplate.isVisible", false) ? (
        <div className="h-full w-full">
          <div className="h-full w-full flex flex-col bg-white">
            <div className="flex gap-8 h-14 ps-8 border-solid">
              {tabs.map((tab) => (
                <div key={tab.id} className="flex flex-col gap-1 pt-3.5">
                  <div
                    className={activeTab === tab.id ? activeButton : singleButtonStyle}
                    onClick={() => setActiveTab(tab.id)}
                  >
                    <Text>{tab.label}</Text>
                  </div>
                  {activeTab === tab.id && (
                    <div
                      className="h-1 rounded-md"
                      style={{
                        backgroundImage:
                          "linear-gradient(96deg, var(--gradient-color) 0%, var(--primary-gradient-color2) 110%)",
                      }}
                    />
                  )}
                </div>
              ))}
            </div>
            {Object.keys(getProjectSettingObject).length && (
              <div className="h-full grow flex-1">
                {activeTab === "INSTANCE_TEMPLATE" && (
                  <Forms
                    formCategory={formCategories.assetsInstance}
                    source={formTemplateSource.projectSettings}
                    projectId={params.projectId}
                  />
                )}
                {activeTab === "PROJECT_LEVEL_TEMPLATE" && (
                  <Suspense fallback={<></>}>
                    {/* Route param: a plain string here, branded on the prop. Erased. */}
                    <FormTemplate
                      projectId={params.projectId as ObjectIdString}
                      resourceType={formCategories.assets.toLowerCase()}
                    />
                  </Suspense>
                )}
              </div>
            )}
          </div>
        </div>
      ) : (
        <Forbidden />
      )}
    </>
  );
}

export default AssetsSetting;
